import { STATUS_CODE } from '~/constants'
import { ENDPOINT } from './endPoint'
import request from './request'
import { logURL } from './config'

// API LOG EVENT USER: Log trên DynamoDB
export const logEventUserApi = async ({
  parent_type,
  parent_id,
  child_type,
  child_id,
  locale,
  position_id,
  action,
}) => {
  const URL = ENDPOINT.LOG_EVENT_USER

  const dataSubmit = {
    parent_type,
    parent_id,
    locale,
    action,
  }

  if (child_type) dataSubmit.child_type = child_type
  if (child_id) dataSubmit.child_id = child_id
  if (position_id) dataSubmit.position_id = position_id

  const myHeaders = {
    'Content-Type': 'application/json',
    'X-Amz-Content-Sha256': 'beaead3198f7da1e70d03ab969765e0821b24fc913697e929e726aeaebf0eba3',
    Authorization:
      'AWS4-HMAC-SHA256 Credential=undefined/20231003/ap-southeast-1/execute-api/aws4_request, SignedHeaders=content-length;content-type;host;x-amz-content-sha256;x-amz-date, Signature=6358b1f4b566176cac66d82396006bb424782a0e239bcfb9d83b6b0106080506',
  }

  try {
    const { data, status } = await request().post(URL, dataSubmit, {
      baseURL: logURL,
      headers: myHeaders,
    })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data || {},
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      error_message: error.response?.data?.message,
    }
  }
}

// Log lên server bình thường
export const logActivitiesUserApi = async ({ action }) => {
  try {
    const { data, status } = await request().post(ENDPOINT.USER_ACTIVITIES, {
      action,
    })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data || {},
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      error_message: error.response?.data?.message,
    }
  }
}
